import React from 'react';
import Icon from '@ant-design/icons';

const MatrixSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
    <g id="Group_25255" data-name="Group 25255" transform="translate(-334 -1357.5)">
      <g id="Group_25257" data-name="Group 25257" transform="translate(812.537 1040.944)">
        <rect
          id="Rectangle_489"
          data-name="Rectangle 489"
          width="15.225"
          height="15.225"
          rx="1.962"
          transform="translate(-478.537 316.556)"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25258" data-name="Group 25258" transform="translate(812.537 1040.944)">
        <rect
          id="Rectangle_490"
          data-name="Rectangle 490"
          width="15.225"
          height="15.225"
          rx="1.962"
          transform="translate(-460.15 316.556)"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25259" data-name="Group 25259" transform="translate(812.537 1040.944)">
        <rect
          id="Rectangle_491"
          data-name="Rectangle 491"
          width="15.225"
          height="15.225"
          rx="1.962"
          transform="translate(-441.762 316.556)"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25260" data-name="Group 25260" transform="translate(812.537 1040.944)">
        <rect
          id="Rectangle_492"
          data-name="Rectangle 492"
          width="15.225"
          height="15.225"
          rx="1.962"
          transform="translate(-478.537 334.943)"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25261" data-name="Group 25261" transform="translate(812.537 1040.944)">
        <path
          id="Path_28647"
          data-name="Path 28647"
          d="M-448.849,338.868v7.376h-7.376v-7.376h7.376m1.962-3.925h-11.3a1.968,1.968,0,0,0-1.963,1.962v11.3a1.968,1.968,0,0,0,1.963,1.962h11.3a1.968,1.968,0,0,0,1.962-1.962V336.9a1.968,1.968,0,0,0-1.962-1.962Z"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25262" data-name="Group 25262" transform="translate(812.537 1040.944)">
        <path
          id="Path_28648"
          data-name="Path 28648"
          d="M-430.462,338.868v7.376h-7.376v-7.376h7.376m1.963-3.925h-11.3a1.968,1.968,0,0,0-1.962,1.962v11.3a1.968,1.968,0,0,0,1.962,1.962h11.3a1.968,1.968,0,0,0,1.962-1.962V336.9a1.968,1.968,0,0,0-1.962-1.962Z"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25263" data-name="Group 25263" transform="translate(812.537 1040.944)">
        <rect
          id="Rectangle_493"
          data-name="Rectangle 493"
          width="15.225"
          height="15.225"
          rx="1.962"
          transform="translate(-478.537 353.33)"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25264" data-name="Group 25264" transform="translate(812.537 1040.944)">
        <path
          id="Path_28649"
          data-name="Path 28649"
          d="M-448.849,357.255v7.376h-7.376v-7.376h7.376m1.962-3.925h-11.3a1.968,1.968,0,0,0-1.963,1.963v11.3a1.968,1.968,0,0,0,1.963,1.963h11.3a1.968,1.968,0,0,0,1.962-1.963v-11.3a1.968,1.968,0,0,0-1.962-1.963Z"
          fill="#7c7c7c"
        />
      </g>
      <g id="Group_25265" data-name="Group 25265" transform="translate(812.537 1040.944)">
        <path
          id="Path_28650"
          data-name="Path 28650"
          d="M-430.462,357.255v7.376h-7.376v-7.376h7.376m1.963-3.925h-11.3a1.968,1.968,0,0,0-1.962,1.963v11.3a1.968,1.968,0,0,0,1.962,1.963h11.3a1.968,1.968,0,0,0,1.962-1.963v-11.3a1.968,1.968,0,0,0-1.962-1.963Z"
          fill="#7c7c7c"
        />
      </g>
    </g>
  </svg>
);

const MatrixIcon = (props) => <Icon component={MatrixSVG} {...props} />;
export default MatrixIcon;
